import {
    loadSurveysRequest,
    loadSurveyRequest,
    syncAnswerRequest,
    completeSurveyRequest,
    loadSurveyAnswers,
    loadSurveyCompanyRequest
} from 'src/repositories/survey.repository';

/**
 * Action Types
 */
export const SURVEYS_LOADING = 'SURVEYS_LOADING';
export const SURVEYS_LOADED = 'SURVEYS_LOADED';
export const SURVEY_LOADING = 'SURVEY_LOADING';
export const SURVEY_LOADED = 'SURVEY_LOADED';
export const ANSWERS_LOADED = 'ANSWERS_LOADED';
export const SURVEY_COMPANY_LOADING = 'SURVEY_COMPANY_LOADING';
export const SURVEY_COMPANY_LOADED = 'SURVEY_COMPANY_LOADED';

/**
 * Action Creators
 */

export const loadingSurveys = isLoading => ({
    type: SURVEYS_LOADING,
    payload: isLoading,
});

export const loadedSurveys = surveys => ({
    type: SURVEYS_LOADED,
    payload: surveys,
});

export const loadingSurvey = isLoading => ({
    type: SURVEY_LOADING,
    payload: isLoading,
});

export const loadedSurvey = survey => ({
    type: SURVEY_LOADED,
    payload: survey,
});

export const loadedAnswers = answers => ({
    type: ANSWERS_LOADED,
    payload: answers,
});

export const loadingSurveyCompany = isLoading => ({
    type: SURVEY_COMPANY_LOADING,
    payload: isLoading
});

export const loadedSurveyCompany = company => ({
    type: SURVEY_COMPANY_LOADED,
    payload: company
});

/**
 * Actions
 */

/**
 * Sync answers with the database
 */
export const syncAnswer = (obj, pk_survey_sent) => () => {
    return syncAnswerRequest(obj, pk_survey_sent);
};

/**
 * Complete a full answered survey
 *  * @param {number} pk_survey_sent
 */
export const completeSurvey = pk_survey_sent => () => {    
    return completeSurveyRequest(pk_survey_sent);
}

/**
 * Load answered questions for a survey
 */
export const loadAnswers = params => dispatch => {
    return loadSurveyAnswers(params).then(({data}) => dispatch(loadedAnswers(data)));
};

/**
 * Load all surveys
 * @param {object} params
 */
export const loadSurveys = params => (dispatch) => {
    dispatch(loadingSurveys(true));
    return loadSurveysRequest(params)
        .then(({data = []}) => {
            dispatch(loadedSurveys(data));
        })
        .finally(() => {
            dispatch(loadingSurveys(false));
        });
};

/**
 * Load specific deal
 * @param {number} id
 */
export const loadSurvey = id => (dispatch) => {
    dispatch(loadingSurvey(true));    
    return loadSurveyRequest(id)
        .then(({ data }) => {
            dispatch(loadedSurvey(data));
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            dispatch(loadingSurvey(false));
        });
};

/**
 * Load the company data for a survey
 *  * @param {number} pk_company
 */
export const loadSurveyCompany = pk_company => (dispatch) => {
    dispatch(loadingSurveyCompany(true));    
    return loadSurveyCompanyRequest(pk_company)
        .then(({ data }) => {
            dispatch(loadedSurveyCompany(data));
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            dispatch(loadingSurveyCompany(false));
        });
}